import { forwardRef, type ReactNode } from 'react'
import { cn } from '../utils/cn.ts'

export interface DescriptionBlockProps {
  children: ReactNode
  className?: string
}

export const DescriptionBlock = forwardRef<HTMLDivElement, DescriptionBlockProps>(
  ({ children, className }, ref) => {
    return (
      <div ref={ref} className={cn('description-block', className)}>
        {children}
      </div>
    )
  },
)

DescriptionBlock.displayName = 'DescriptionBlock'
